var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ma-0 pa-0" },
    [
      _vm.isLoading
        ? _c(
            "v-layout",
            {
              staticStyle: {
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                "z-index": "1000",
                background: "rgba(255, 255, 255, .95)"
              },
              attrs: { "align-center": "", "justify-center": "" }
            },
            [
              _c("div", { staticClass: "primary--text" }, [
                _c("div", { staticClass: "lds-roller" }, [
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div")
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Patientez SVP ...")])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          attrs: {
            row: "",
            wrap: "",
            "mx-4": "",
            "pl-0": "",
            "mt-0": "",
            "mb-3": ""
          }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", "mt-2": "" } },
            [
              _c("h1", { staticClass: "primary--text" }, [
                _vm._v(_vm._s(_vm.$t(_vm.lblSetting.blockOverallInformations)))
              ]),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs2: "" } },
                [
                  _c("v-card", {
                    attrs: {
                      flat: "",
                      color: "secondary",
                      height: "1px",
                      width: "100%"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.currentEquipment
                ? _c(
                    "v-card",
                    {
                      staticClass: "py-3 pr-1 pl-4 mt-2",
                      class: { "grey--text": _vm.currentEquipment.disable }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c("v-flex", { attrs: { xs3: "" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "equipment--picture",
                                style: _vm.equipmentBgContainerStyle,
                                attrs: { size: "95%", color: "grey lighten-4" },
                                on: {
                                  mouseover: _vm.handleImageMouseOver,
                                  mouseleave: _vm.handleImageMouseLeave
                                }
                              },
                              [
                                _vm.currentEquipment.picture
                                  ? _c("img", {
                                      directives: [
                                        { name: "img", rawName: "v-img" }
                                      ],
                                      ref: "btn_zoom",
                                      staticStyle: { display: "none" },
                                      attrs: {
                                        src: _vm.currentEquipment.picture
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.hoverImg
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "equipment_picture_action"
                                      },
                                      [
                                        _vm.currentEquipment.picture
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  large: "",
                                                  color: "grey lighten-4",
                                                  icon: ""
                                                },
                                                on: {
                                                  click: _vm.handleZoomPicture
                                                }
                                              },
                                              [
                                                _c("v-icon", [
                                                  _vm._v("zoom_out_map")
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.currentEquipment.picture &&
                                        _vm.$route.meta["manage_equipment"]
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  large: "",
                                                  color: "grey lighten-4",
                                                  icon: ""
                                                },
                                                on: {
                                                  click: _vm.handleClickPicture
                                                }
                                              },
                                              [_c("v-icon", [_vm._v("edit")])],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.currentEquipment.picture &&
                                        _vm.$route.meta["manage_equipment"]
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  large: "",
                                                  alt: "Add picture",
                                                  color: "grey lighten-4",
                                                  icon: ""
                                                },
                                                on: {
                                                  click: _vm.handleClickPicture
                                                }
                                              },
                                              [_c("v-icon", [_vm._v("add")])],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.loadUpdateImage
                                  ? _c("v-progress-circular", {
                                      staticClass: "equipment_picture_action",
                                      attrs: {
                                        indeterminate: "",
                                        color: "secondary"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("input", {
                              ref: "file",
                              staticStyle: { display: "none" },
                              attrs: {
                                type: "file",
                                id: "file",
                                accept: "image/png, image/jpeg"
                              },
                              on: {
                                change: function($event) {
                                  _vm.handleFileUpload($event.target)
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs3: "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-layout", { attrs: { column: "" } }, [
                                    _vm.currentEquipment.disable
                                      ? _c(
                                          "strong",
                                          { staticClass: "black--text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.lblSetting.equipmentDetail
                                                    .disable
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            _vm.lblSetting.equipmentHeaders.name
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("label", [
                                      _vm._v(_vm._s(_vm.currentEquipment.name))
                                    ]),
                                    _vm._v(" "),
                                    _c("strong", { staticClass: "mt-1" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            _vm.lblSetting.equipmentModal.brand
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentEquipment.brand || "-"
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("strong", { staticClass: "mt-1" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            _vm.lblSetting.equipmentModal
                                              .reference
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      { staticClass: "italic--text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentEquipment.reference ||
                                              "-"
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("strong", { staticClass: "mt-1" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            _vm.lblSetting.blockHeaderApartment
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentEquipment.apartment
                                            ? _vm.currentEquipment.apartment
                                                .apartment_number
                                            : "-"
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("strong", { staticClass: "mt-1" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            _vm.lblSetting.equipmentHeaders
                                              .location
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentEquipment.location || "-"
                                        )
                                      )
                                    ])
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs3: "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { shrink: "", "mr-3": "" } },
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { column: "" } },
                                        [
                                          _c(
                                            "v-avatar",
                                            {
                                              attrs: {
                                                color: _vm.avatarColor,
                                                size: "40"
                                              }
                                            },
                                            [
                                              _c("img", {
                                                staticStyle: {
                                                  width: "30px",
                                                  height: "30px"
                                                },
                                                attrs: {
                                                  src:
                                                    _vm.currentEquipment
                                                      .category.picto
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.currentEquipment
                                            .fk_character_problem_lvl2
                                            ? _c(
                                                "v-avatar",
                                                {
                                                  staticClass: "mt-2",
                                                  attrs: {
                                                    color: _vm.avatarColor,
                                                    size: "40"
                                                  }
                                                },
                                                [
                                                  _c("img", {
                                                    staticStyle: {
                                                      width: "30px",
                                                      height: "30px"
                                                    },
                                                    attrs: {
                                                      src:
                                                        _vm.currentEquipment
                                                          .subcategory.picto
                                                    }
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-layout", { attrs: { column: "" } }, [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            _vm.lblSetting.equipmentHeaders
                                              .charPb1
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentEquipment.category.name
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.currentEquipment
                                      .fk_character_problem_lvl2
                                      ? _c("span", [
                                          _c(
                                            "strong",
                                            { staticClass: "mt-1" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.lblSetting
                                                      .equipmentHeaders.charPb2
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentEquipment.subcategory
                                                  .name
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("strong", { staticClass: "mt-1" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            _vm.lblSetting.equipmentModal.number
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentEquipment
                                            .number_equipment > 0
                                            ? _vm.currentEquipment
                                                .number_equipment
                                            : "1"
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("strong", { staticClass: "mt-1" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            _vm.lblSetting.equipmentHeaders
                                              .description
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentEquipment.description ||
                                            "-"
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("strong", { staticClass: "mt-1" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            _vm.lblSetting.equipmentDetail
                                              .acquisitionDate
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentEquipment
                                            .acquisition_date || "-"
                                        )
                                      )
                                    ])
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs3: "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "", "mt-1": "" } },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          _vm.lblSetting.equipmentHeaders.follow
                                        )
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "", "mt-0": "" } },
                                [
                                  !_vm.coLoader
                                    ? _c(
                                        "v-layout",
                                        { attrs: { column: "", wrap: "" } },
                                        [
                                          _vm.currentEquipment
                                            .contractors_assigned &&
                                          _vm.currentEquipment
                                            .contractors_assigned.length === 1
                                            ? _c(
                                                "user-profile-enhanced-widget",
                                                {
                                                  attrs: {
                                                    user:
                                                      _vm.currentEquipment
                                                        .contractors_assigned[0],
                                                    "two-line": true,
                                                    disable:
                                                      _vm.currentEquipment
                                                        .disable
                                                  }
                                                }
                                              )
                                            : _vm.currentEquipment
                                                .contractors_assigned.length > 1
                                            ? _c(
                                                "v-carousel",
                                                {
                                                  staticClass: "elevation-0",
                                                  attrs: {
                                                    height: "200",
                                                    cycle: false,
                                                    light: true
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.currentEquipment
                                                    .contractors_assigned,
                                                  function(contractor, index) {
                                                    return _c(
                                                      "v-carousel-item",
                                                      { key: index },
                                                      [
                                                        _c(
                                                          "v-layout",
                                                          {
                                                            attrs: {
                                                              row: "",
                                                              wrap: "",
                                                              "justify-center":
                                                                ""
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-flex",
                                                              {
                                                                attrs: {
                                                                  xs12: "",
                                                                  "ml-2": ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "user-profile-widget",
                                                                  {
                                                                    attrs: {
                                                                      user: contractor,
                                                                      disable:
                                                                        _vm
                                                                          .currentEquipment
                                                                          .disable
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            : _c("strong", [_vm._v("-")])
                                        ],
                                        1
                                      )
                                    : _c(
                                        "v-flex",
                                        { attrs: { xs12: "" } },
                                        [
                                          _c("block-infos-loader", {
                                            attrs: { height: 10, width: 220 }
                                          })
                                        ],
                                        1
                                      )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$route.meta["view_equipment_attribute"] &&
              _vm.currentEquipment &&
              _vm.currentEquipment.attributes.length
                ? _c(
                    "div",
                    { staticClass: "mt-4" },
                    [
                      _c("h1", { staticClass: "primary--text mt-2" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(_vm.lblSetting.blockEquipment.attributes)
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs1: "" } },
                        [
                          _c("v-card", {
                            attrs: {
                              flat: "",
                              color: "secondary",
                              height: "1px",
                              width: "100%"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { staticClass: "py-3 pr-1 pl-4 mt-2" },
                        [
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                "pr-1": "",
                                "pl-4": "",
                                row: "",
                                wrap: ""
                              }
                            },
                            _vm._l(_vm.currentEquipment.attributes, function(
                              item
                            ) {
                              return _c(
                                "v-flex",
                                {
                                  key: item.id,
                                  attrs: { xs4: "", "px-3": "" }
                                },
                                [
                                  _c("v-hover", {
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var hover = ref.hover
                                          return _c(
                                            "base-attribute-value",
                                            { attrs: { attribute: item } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  attrs: { "text-xs-left": "" }
                                                },
                                                [
                                                  hover &&
                                                  _vm.$route.meta[
                                                    "manage_equipment_attribute"
                                                  ]
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            color: "primary",
                                                            small: "",
                                                            flat: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.handleEditAttribute(
                                                                item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "mr-1",
                                                              attrs: {
                                                                small: ""
                                                              }
                                                            },
                                                            [_vm._v("edit")]
                                                          ),
                                                          _vm._v(
                                                            "\n                      Modifier\n                    "
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _c("div", {
                                                        staticStyle: {
                                                          height: "40px"
                                                        }
                                                      })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("last-documents", {
                key: _vm.lastDocsKey,
                attrs: {
                  equipmentId: _vm.$route.params.cid,
                  equipmentName: _vm.getEquipmentName()
                },
                on: { "update-doc-by-id": _vm.updateDocById }
              }),
              _vm._v(" "),
              _vm.maintenances.length
                ? _c(
                    "div",
                    { staticClass: "mt-4" },
                    [
                      _c("h1", { staticClass: "primary--text mt-2" }, [
                        _vm._v("Maintenances")
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "mb-4", attrs: { xs1: "" } },
                        [
                          _c("v-card", {
                            attrs: {
                              flat: "",
                              color: "secondary",
                              height: "1px",
                              width: "100%"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            { staticStyle: { padding: "30px 90px 30px 90px" } },
                            _vm._l(_vm.maintenances, function(item) {
                              return _c(
                                "div",
                                { key: item.id },
                                [
                                  _c("maintenance-item", {
                                    attrs: { maintenance: item }
                                  })
                                ],
                                1
                              )
                            })
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.dtModalAttribute
        ? _c(
            "base-modal-duplicate",
            {
              attrs: {
                "show-create-another": false,
                loading: _vm.dtIsRecording,
                icon: "handyman",
                "icon-type": "icon",
                "submit-btn-title": _vm.$t(this.lblSetting.blockSave),
                "hide-default-action": true,
                title:
                  _vm.$t(this.lblSetting.blockEquipment.updateAttribute) +
                  _vm.currentAttribute.name,
                "is-dark-title": "",
                "max-width": "50vw",
                "before-close": _vm.handleBeforeModalClose
              },
              on: {
                onRecord: _vm.handleSaveAttribute,
                onClose: _vm.handleClose
              },
              model: {
                value: _vm.dtModalAttribute,
                callback: function($$v) {
                  _vm.dtModalAttribute = $$v
                },
                expression: "dtModalAttribute"
              }
            },
            [
              _c(
                "v-layout",
                { attrs: { wrap: "", "px-0": "" } },
                [
                  _c(
                    "v-flex",
                    {
                      staticClass: "form-section",
                      attrs: { "pl-4": "", xs12: "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { "pl-0": "", "pr-4": "", xs12: "" } },
                            [
                              _c("base-attribute-manager", {
                                attrs: { attribute: _vm.currentAttribute },
                                model: {
                                  value: _vm.attributeToEdit,
                                  callback: function($$v) {
                                    _vm.attributeToEdit = $$v
                                  },
                                  expression: "attributeToEdit"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "base-modal-duplicate",
        {
          ref: "base-modal",
          attrs: {
            loading: _vm.dtIsRecording,
            "action-position": "center",
            icon: "document_bleu",
            "before-close": _vm.handleBeforeModalClose,
            "submit-btn-title": _vm.$t(_vm.lblSetting.documentSave),
            "hide-default-action": true,
            title: _vm.modalTitle,
            "max-width": "90%",
            "is-yellow-title": ""
          },
          on: { onRecord: _vm.handleSaveDoc, onClose: _vm.handleClose },
          model: {
            value: _vm.dtModalAddDoc,
            callback: function($$v) {
              _vm.dtModalAddDoc = $$v
            },
            expression: "dtModalAddDoc"
          }
        },
        [
          _c("document-modal-vertical", {
            attrs: { equipment: _vm.dtEquipment }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.dtMessageErrorModel
        ? _c("base-error-dialog", {
            attrs: { error: _vm.dtError },
            on: { cancel: _vm.handleRemoveError }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-429270af", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-429270af","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/block-equipment-detail/template.html
// module id = null
// module chunks = 